import { Input } from "rsuite";
import React from 'react';

const TextArea = React.forwardRef((props, ref) => (
    <Input {...props} as="textarea" ref={ref} />
));

export default TextArea